import angular from 'angular';
import { AttService } from './AttService';

angular.module('sh.attService', ['sh.modal', 'sh.api', 'sh.urlData']).service('Att', AttService);
